module.exports = {"ProjectOptions":{"defaultLang":"ro","langArr":["ro","ru"]}}


//////////////////
// WEBPACK FOOTER
// ./appsettings.json
// module id = 12
// module chunks = 0